/**
 * This method is here for consistency, so we have something in place in case we
 * need to modify the data returned by the API.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  offer     The offer data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformOffer = function(language, offer) {
    return offer;
};
